import { render, staticRenderFns } from "./healthcare.vue?vue&type=template&id=6f203a40&scoped=true&"
import script from "./healthcare.vue?vue&type=script&lang=js&"
export * from "./healthcare.vue?vue&type=script&lang=js&"
import style0 from "./healthcare.vue?vue&type=style&index=0&id=6f203a40&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f203a40",
  null
  
)

export default component.exports